import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../../BenjiKIV";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {gsap} from "gsap";
import {BenjiKIVGameAssets} from "../../../BenjiKIVGameAssets";
import {BenjiKIVStatics} from "../../../BenjiKIVStatics";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {BenjiKIVRingGirl} from "./BenjiKIVRingGirl";
import {BenjiKIVSound} from "../../../sound/BenjiKIVSound";
import {BenjiKIVOverlayScatterSymbol} from "../../../reels/BenjiKIVOverlayScatterSymbol";
import {BenjiKIVGameMode} from "../../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-11-03.
 */

export class BenjiKIVEnhancerView extends PIXI.Container implements StageLayer {

    private static ENHANCER_POSITIONS: PIXI.Point[] = [new PIXI.Point(70, 137), new PIXI.Point(214, 137),
        new PIXI.Point(358, 137), new PIXI.Point(502, 137), new PIXI.Point(646, 137)];
    private static RING_GIRL_POSITIONS: PIXI.Point[] = [new PIXI.Point(70, 300), new PIXI.Point(212, 300), new PIXI.Point(355, 300), new PIXI.Point(497, 300), new PIXI.Point(642, 300)];

    private _enhancers: PIXI.Sprite[];
    private _enhancerContainers: PIXI.Container[];
    private _darkEmptyRings: PIXI.Sprite[];
    private _darkOverlays: PIXI.Sprite[];
    private _activeBoxerAnimations: TimelineSprite[];
    private _activeRopeJumpingAnimations: TimelineSprite[];
    private _activeTrainingBoxerAnimations: TimelineSprite[];
    private _activateFightersTLs: gsap.core.Timeline[] = [];
    private _activateTrainingTLs: gsap.core.Timeline[] = [];
    private _activateRopeJumpingTLs: gsap.core.Timeline[] = [];
    private _xSplits: PIXI.Container[];
    private _xSplitXs: PIXI.Sprite[];
    private _multiplierTexts: PIXI.BitmapText[];
    private _boxerAnimationTexturesLength: number;
    private _trainingBoxerAnimationTexturesLength: number;
    private _ropeJumpingAnimationTexturesLength: number;
    private _ringGirls: BenjiKIVRingGirl[];
    private _xReelAttentions: PIXI.Sprite[];
    private _deActivateDarkOverlayTLs: gsap.core.Timeline[];
    private _activateDarkOverlayTLs: gsap.core.Timeline[];
    private _isShowEnhancerAborted: boolean = false;
    private _isSpinResultAborted: boolean = false;
    private _abortedEnhancerPlayed: boolean = false;
    private _xsplitAnticPlayed: boolean = false;

    constructor() {
        super();
        this.name = "BenjiKIVEnhancerView";

        this.init();

        if (BenjiKIV.model.isRestore == true) {
            if (BenjiKIV.model.data.enhancerReel) {
                for (let i: number = 0; i < BenjiKIV.model.data.enhancerReel.length; i++) {
                    if (BenjiKIV.model.data.enhancerReel[i] == 1) {
                        //Restore split
                        this._xSplits[i].visible = true;
                        this.deActivateDarkRing(i);
                        if (this.checkRestoreIntoBonusIntro() == true) {
                            this.activateDarkOverlay(i);
                        }
                    } else if (BenjiKIV.model.data.enhancerReel[i] > 1) {
                        //Restore multi
                        this._multiplierTexts[i].text = BenjiKIV.model.data.enhancerReel[i] + "x";
                        this._multiplierTexts[i].visible = true;
                        this.deActivateDarkRing(i);
                        if (this.checkRestoreIntoBonusIntro() == true) {
                            this.activateDarkOverlay(i);
                        }
                    }
                }
            }
        }
    }

    public asSetEnhancerFeatures(): void {
        if (BenjiKIV.model.data.enhancerReel) {
            for (let i: number = 0; i < BenjiKIV.model.data.enhancerReel.length; i++) {
                if (BenjiKIV.model.data.enhancerReel[i] == 1) {
                    this._xSplits[i].visible = true;
                    this.deActivateDarkRing(i);
                    this.activateDarkOverlay(i);
                } else if (BenjiKIV.model.data.enhancerReel[i] > 1) {
                    this._multiplierTexts[i].text = BenjiKIV.model.data.enhancerReel[i] + "x";
                    this._multiplierTexts[i].visible = true;
                    this.deActivateDarkRing(i);
                    this.activateDarkOverlay(i);
                }
            }
        }
    }

    public activateDarkRing(reelId: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._darkEmptyRings[reelId].alpha = 0
        });
        tl.add([
            gsap.to(this._darkEmptyRings[reelId], {duration: 0.2, alpha: 1})
        ]);

        return tl;
    }

    public deActivateDarkRing(reelId: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._darkEmptyRings[reelId].alpha = 1
        });
        tl.add([
            gsap.to(this._darkEmptyRings[reelId], {duration: 0.2, alpha: 0})
        ]);
        return tl;
    }

    public activateDarkOverlay(reelId: number, duration: number = 0.2): gsap.core.Timeline {
        if (this._deActivateDarkOverlayTLs[reelId].isActive()) {
            this._deActivateDarkOverlayTLs[reelId].pause();
        }

        return this._activateDarkOverlayTLs[reelId].restart();
    }

    public deActivateDarkOverlay(reelId: number): gsap.core.Timeline {
        if (this._activateDarkOverlayTLs[reelId].isActive()) {
            this._activateDarkOverlayTLs[reelId].pause();
        }
        return this._deActivateDarkOverlayTLs[reelId].restart();
    }

    public activateAllFighters(): void {
        this.createActivateAllFightersTL();
        for (let i: number = 0; i < BenjiKIV.model.data.reels.length; i++) {
            if (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) {
                this._activateRopeJumpingTLs[i].restart();
            } else if (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN) {
                this._activateTrainingTLs[i].restart();
            } else {
                this._activateFightersTLs[i].restart();
            }

            this.deActivateDarkRing(i);
        }
    }

    public getDarkDownAllEnhancerPositions(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        for (let i: number = 1; i < this._darkOverlays.length; i++) {
            tl.add(() => {
                this._darkOverlays[i].alpha = 0
            });
            tl.add(() => {
                gsap.to(this._darkOverlays[i], {duration: 0.3, alpha: 0.8})
            });
        }
        return tl;
    }

    public xSplitReelAttentionOn(reelId: number): gsap.core.Timeline {
        const xAttentionTL: gsap.core.Timeline = gsap.timeline();
        if (BenjiKIV.model.data.enhancerReel[reelId] == 1) {
            xAttentionTL.add(() => {
                this._xReelAttentions[reelId].alpha = 0
            });
            xAttentionTL.add(() => {
                this._xReelAttentions[reelId].visible = true
            });
            xAttentionTL.add(() => {
                if (this._isSpinResultAborted == false) {
                    BenjiKIV.soundPlayer.playSound(BenjiKIVSound.XSPLIT_ANTICIPATION)
                } else if (this._xsplitAnticPlayed == false) {
                    this._xsplitAnticPlayed = true;
                    BenjiKIV.soundPlayer.playSound(BenjiKIVSound.XSPLIT_ANTICIPATION)
                }
            });
            xAttentionTL.add(gsap.to(this._xReelAttentions, {duration: 0.2, alpha: 1}));
            xAttentionTL.add(() => {
                this._xReelAttentions[reelId].alpha = 1
            });
            //This delay will prolong the spin on this reel
            xAttentionTL.add(gsap.timeline({delay: BenjiKIVStatics.X_SPLIT_ATTENTION_REEL_DELAY}));
        }
        return xAttentionTL;
    }

    public xReelAttentionOff(reelId: number): void {
        if (this._xReelAttentions[reelId].alpha > 0) {
            const xAttentionOffTL: gsap.core.Timeline = gsap.timeline();
            xAttentionOffTL.add(() => {
                this._xReelAttentions[reelId].alpha = 1
            });
            xAttentionOffTL.add(gsap.to(this._xReelAttentions, {duration: 0.1, alpha: 0}));
            xAttentionOffTL.add(() => {
                this._xReelAttentions[reelId].visible = false
            });
            xAttentionOffTL.add(() => {
                this._xReelAttentions[reelId].alpha = 0
            });
        }
    }

    public getRingGirlShowSplitAnimation(reelId: number): gsap.core.Timeline {
        let ringGirl: BenjiKIVRingGirl = this._ringGirls[reelId];
        const ringGirlTL: gsap.core.Timeline = gsap.timeline();
        ringGirlTL.add(() => {
            ringGirl.position = BenjiKIVEnhancerView.RING_GIRL_POSITIONS[reelId];
            ringGirl.visible = true;
        });
        ringGirlTL.add(ringGirl.getRingGirlShowSplitAnimation());

        ringGirlTL.add(() => {
            ringGirl.visible = false;
            ringGirl.isUsed = false;
        });

        return ringGirlTL;
    }

    public showResult(reelId: number): gsap.core.Timeline {
        const resultTL: gsap.core.Timeline = gsap.timeline();
        //If several overlays get upgraded on same reel, we only play one sound
        const playOverlayUpgradeSound: boolean[] = [true, true, true, true, true];
        resultTL.add(() => {
            if (this._isShowEnhancerAborted == false) {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.ENHANCER_RESULT)
            } else if (this._abortedEnhancerPlayed == false) {
                this._abortedEnhancerPlayed = true;
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.ENHANCER_RESULT)
            }
        });
        let allOverlaysOnReel: BenjiKIVOverlayScatterSymbol[] = BenjiKIV.overlayScatterView.getAllOverlaysOnReel(reelId);
        switch (BenjiKIV.model.data.enhancerReel[reelId]) {
            case 0:
                //No win, no ring girl
                resultTL.add(() => {
                    this.deActivateDarkOverlay(reelId);
                    this._activateFightersTLs[reelId].pause();
                    this._activateTrainingTLs[reelId].pause();
                    this._activateRopeJumpingTLs[reelId].pause();
                    this._activeBoxerAnimations[reelId].visible = false;
                    this._activeTrainingBoxerAnimations[reelId].visible = false;
                    this._activeRopeJumpingAnimations[reelId].visible = false;
                });
                resultTL.add(() => {
                    this.activateDarkRing(reelId)
                }, "+=0.4");
                break;
            case 1:
                if (allOverlaysOnReel.length > 0) {
                    resultTL.add(() => {
                        this.deActivateDarkOverlay(reelId);
                        this._xSplits[reelId].visible = true;
                        this._activateFightersTLs[reelId].pause();
                        this._activateTrainingTLs[reelId].pause();
                        this._activateRopeJumpingTLs[reelId].pause();
                        this._activeBoxerAnimations[reelId].visible = false;
                        this._activeTrainingBoxerAnimations[reelId].visible = false;
                        this._activeRopeJumpingAnimations[reelId].visible = false;
                    }, "-=0.2");
                    if (allOverlaysOnReel.length > 0) {
                        const overlayUpdateTLs: gsap.core.Timeline[] = [];
                        for (let j: number = 0; j < allOverlaysOnReel.length; j++) {
                            //Split all overlay scatter on reel
                            overlayUpdateTLs.push(allOverlaysOnReel[j].getUpdateMultiplierTL(allOverlaysOnReel[j].multiplierValue * 2, playOverlayUpgradeSound[reelId]));
                            playOverlayUpgradeSound[reelId] = false;
                        }

                        resultTL.add(gsap.to(this._xSplitXs[reelId].scale, 0.2, {
                            x: 1.4,
                            y: 1.4
                        }));
                        resultTL.add(gsap.to(this._xSplitXs[reelId].scale, 0.15, {
                            x: 0.9,
                            y: 0.9
                        }));
                        resultTL.add(gsap.to(this._xSplitXs[reelId].scale, 0.1, {
                            x: 1,
                            y: 1
                        }));
                        resultTL.add(overlayUpdateTLs, "-=0.1");
                    }
                } else {
                    //No overlay on reel, just show enhancer split
                    resultTL.add(() => {
                        this.deActivateDarkOverlay(reelId);
                        this._xSplits[reelId].visible = true;
                        this._activateFightersTLs[reelId].pause();
                        this._activateTrainingTLs[reelId].pause();
                        this._activateRopeJumpingTLs[reelId].pause();
                        this._activeBoxerAnimations[reelId].visible = false;
                        this._activeTrainingBoxerAnimations[reelId].visible = false;
                        this._activeRopeJumpingAnimations[reelId].visible = false;
                    });
                    resultTL.add(gsap.timeline({delay: 0.4}));
                }
                break;
            default:
                if (BenjiKIV.model.overlayScatterOnReel(reelId)) {
                    resultTL.add(() => {
                        this.deActivateDarkOverlay(reelId);
                        this._multiplierTexts[reelId].text = BenjiKIV.model.data.enhancerReel[reelId] + "x";
                        this._multiplierTexts[reelId].visible = true;
                        this._activateFightersTLs[reelId].pause();
                        this._activateTrainingTLs[reelId].pause();
                        this._activateRopeJumpingTLs[reelId].pause();
                        this._activeBoxerAnimations[reelId].visible = false;
                        this._activeTrainingBoxerAnimations[reelId].visible = false;
                        this._activeRopeJumpingAnimations[reelId].visible = false;
                    });
                    if (allOverlaysOnReel.length > 0) {
                        //Update all scatter overlays on the reel with enhancer multiplier
                        const overlayUpdateTLs: gsap.core.Timeline[] = [];
                        for (let j: number = 0; j < allOverlaysOnReel.length; j++) {
                            if (BenjiKIV.model.data.enhancerReel[reelId] > 1) {
                                //Multiplier
                                overlayUpdateTLs.push(allOverlaysOnReel[j].getUpdateMultiplierTL(allOverlaysOnReel[j].multiplierValue + BenjiKIV.model.data.enhancerReel[reelId], playOverlayUpgradeSound[reelId]));
                                playOverlayUpgradeSound[reelId] = false;
                            }
                        }
                        resultTL.add(gsap.to(this._multiplierTexts[reelId].scale, 0.2, {
                            x: 1.4,
                            y: 1.4
                        }));
                        resultTL.add(gsap.to(this._multiplierTexts[reelId].scale, 0.15, {
                            x: 0.9,
                            y: 0.9
                        }));
                        resultTL.add(gsap.to(this._multiplierTexts[reelId].scale, 0.1, {
                            x: 1,
                            y: 1
                        }));
                        resultTL.add(overlayUpdateTLs, "-=0.1");
                        resultTL.add(() => {
                            this.activateDarkOverlay(reelId, 0.2);
                        }, "-=0.2");
                    } else {
                        //No scatter overlay to update on this reel
                        resultTL.add(() => {
                            this.activateDarkOverlay(reelId, 0.1);
                        });
                    }
                } else {
                    resultTL.add(() => {
                        this.deActivateDarkOverlay(reelId);
                        this._multiplierTexts[reelId].text = BenjiKIV.model.data.enhancerReel[reelId] + "x";
                        this._multiplierTexts[reelId].visible = true;
                        this._activateFightersTLs[reelId].pause();
                        this._activateTrainingTLs[reelId].pause();
                        this._activateRopeJumpingTLs[reelId].pause();
                        this._activeBoxerAnimations[reelId].visible = false;
                        this._activeTrainingBoxerAnimations[reelId].visible = false;
                        this._activeRopeJumpingAnimations[reelId].visible = false;
                    });
                    resultTL.add(() => {
                        this.activateDarkOverlay(reelId, 0.1)
                    }, "+=0.4");
                }
                break;
        }
        return resultTL;
    }

    public reset(): void {
        this._isShowEnhancerAborted = false;
        this._abortedEnhancerPlayed = false;
        this._xsplitAnticPlayed = false;
        for (let i: number = 0; i < 5; i++) {
            this._multiplierTexts[i].visible = false;
            this._xSplits[i].visible = false;
            this._activeBoxerAnimations[i].visible = false;
            this._activeTrainingBoxerAnimations[i].visible = false;
            this._activeRopeJumpingAnimations[i].visible = false;
            this._darkEmptyRings[i].visible = true;
            this._darkEmptyRings[i].alpha = 1;
            this._darkOverlays[i].alpha = 0;
        }
    }

    private checkRestoreIntoBonusIntro(): boolean {
        if (BenjiKIV.model.isRestore == true) {
            if ((BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)) {
                return true;
            }
            if ((BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)) {
                return true;
            }
            return false;
        }
        return false;
    }

    private init(): void {
        this._xReelAttentions = [];
        this._deActivateDarkOverlayTLs = [];
        this._activateDarkOverlayTLs = [];
        for (let i: number = 0; i < 5; i++) {
            this._xReelAttentions.unshift(new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.XSPLIT_REEL_ATTENTION)[0]));
            this._xReelAttentions[0].blendMode = PIXI.BLEND_MODES.ADD;
            this._xReelAttentions[0].x = BenjiKIVStatics.reelPositions[0 + i].x;
            this._xReelAttentions[0].y = BenjiKIVStatics.symbolHeight * 1 + 16;
            this._xReelAttentions[0].visible = false;
            this.addChild(this._xReelAttentions[0]);
        }
        this._xReelAttentions.reverse();
        this._enhancers = [];
        let enhancer: PIXI.Sprite;
        this._enhancerContainers = [];
        let container: PIXI.Container;
        this._activeBoxerAnimations = [];
        const activeBoxerAnimationTextures: PIXI.Texture[] = BenjiKIV.assetLoader.getTextures("Enhacers_Fight/Fight_");
        this._boxerAnimationTexturesLength = activeBoxerAnimationTextures.length - 1;
        this._activeRopeJumpingAnimations = [];
        const activeRopeJumpingAnimationTextures: PIXI.Texture[] = BenjiKIV.assetLoader.getTextures("Enhancers_Jump/Jump_");
        this._ropeJumpingAnimationTexturesLength = activeRopeJumpingAnimationTextures.length - 1;
        this._activeTrainingBoxerAnimations = [];
        const activeTrainingBoxerAnimationTextures: PIXI.Texture[] = BenjiKIV.assetLoader.getTextures("Enhancers_Shadowfight/Shadowfight_");
        this._trainingBoxerAnimationTexturesLength = activeTrainingBoxerAnimationTextures.length - 1;
        let darkEmptyRing: PIXI.Sprite;
        this._darkEmptyRings = [];
        let xSplitContainer: PIXI.Container;
        let xSplitBG: PIXI.Sprite;
        let xSplitX: PIXI.Sprite;
        this._xSplits = [];
        this._xSplitXs = [];
        let multiplierText: PIXI.BitmapText;
        this._multiplierTexts = [];
        this._darkOverlays = [];
        let darkOverlay: PIXI.Sprite;
        this._ringGirls = [];
        for (let i: number = 0; i < 5; i++) {
            container = new PIXI.Container;
            container.position = BenjiKIVEnhancerView.ENHANCER_POSITIONS[i];

            enhancer = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("Enhancers/E_" + "BG")[0]);
            enhancer.anchor.set(0.5, 0.5);
            this._enhancers.push(enhancer);
            container.addChild(enhancer);

            let activeBoxer: TimelineSprite = new TimelineSprite(activeBoxerAnimationTextures);
            activeBoxer.anchor.set(0.5, 0.5);
            activeBoxer.visible = false;
            this._activeBoxerAnimations.push(activeBoxer);
            container.addChild(activeBoxer);

            let activeRopeJumper: TimelineSprite = new TimelineSprite(activeRopeJumpingAnimationTextures);
            activeRopeJumper.anchor.set(0.5, 0.5);
            activeRopeJumper.visible = false;
            this._activeRopeJumpingAnimations.push(activeRopeJumper);
            container.addChild(activeRopeJumper);

            let activeTrainingBoxer: TimelineSprite = new TimelineSprite(activeTrainingBoxerAnimationTextures);
            activeTrainingBoxer.anchor.set(0.5, 0.5);
            activeTrainingBoxer.visible = false;
            this._activeTrainingBoxerAnimations.push(activeTrainingBoxer);
            container.addChild(activeTrainingBoxer);

            xSplitContainer = new PIXI.Container();
            xSplitContainer.visible = false;
            xSplitBG = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("Enhancers/E_Xsplit")[0]);
            xSplitBG.anchor.set(0.5, 0.5);
            xSplitContainer.addChild(xSplitBG);
            xSplitX = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("Enhancers/xsplit_x")[0]);
            xSplitX.anchor.set(0.5, 0.5);
            xSplitContainer.addChild(xSplitX);
            this._xSplitXs.push(xSplitX);
            container.addChild(xSplitContainer);
            this._xSplits.push(xSplitContainer);

            multiplierText = new PIXI.BitmapText("x2", {
                fontName: BenjiKIVGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER,
                fontSize: 45
            });
            multiplierText.anchor = new PIXI.Point(0.5, 0.5);
            multiplierText.position.x = -10;
            multiplierText.visible = false;
            container.addChild(multiplierText);
            this._multiplierTexts.push(multiplierText);

            darkEmptyRing = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("Enhancers/E_BG_Off")[0]);
            darkEmptyRing.anchor.set(0.5, 0.5);
            container.addChild(darkEmptyRing);
            this._darkEmptyRings.push(darkEmptyRing);

            darkOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
            darkOverlay.tint = 0x000000;
            darkOverlay.alpha = 0;
            darkOverlay.anchor.set(0.5, 0.5);
            darkOverlay.width = container.width;
            darkOverlay.height = container.height;
            this._darkOverlays.push(darkOverlay);
            container.addChild(darkOverlay);

            this._enhancerContainers.push(container);
            this.addChild(container);

            const ringGirl: BenjiKIVRingGirl = BenjiKIV.ringGirlsPool.getGirl();
            ringGirl.visible = false;
            BenjiKIV.totalWinView.addChild(ringGirl);
            this._ringGirls.push(ringGirl);
        }

        for (let i: number = 0; i < 5; i++) {
            const tl: gsap.core.Timeline = gsap.timeline({paused: true});
            tl.add(gsap.to(this._darkOverlays[i], {duration: 0.2, alpha: 0}));
            this._deActivateDarkOverlayTLs.push(tl);

            const tl2: gsap.core.Timeline = gsap.timeline({paused: true});
            tl2.add(gsap.to(this._darkOverlays[i], {duration: 0.2, alpha: 0.8}));
            this._activateDarkOverlayTLs.push(tl2);
        }

        this.createActivateAllFightersTL();
        this.createActivateRopeJumpersTL();
        this.createActivateBoxTrainersTL();
    }

    private createActivateAllFightersTL(): void {
        this._activateFightersTLs = [];
        for (let i: number = 0; i < this._activeBoxerAnimations.length; i++) {
            const tl: gsap.core.Timeline = gsap.timeline({paused: true});
            tl.add(() => {
                this._activeBoxerAnimations[i].visible = true
            });
            //Start boxer animation at random position, then loop
            tl.add(this._activeBoxerAnimations[i].getAnimation([MathHelper.randomIntInRange(0, this._boxerAnimationTexturesLength), this._boxerAnimationTexturesLength]).timeScale(0.25));
            tl.add(gsap.timeline({repeat: -1}).add(this._activeBoxerAnimations[i].getAnimation().timeScale(0.25)));
            this._activateFightersTLs.push(tl);
        }
    }

    private createActivateRopeJumpersTL(): void {
        this._activateRopeJumpingTLs = [];
        for (let i: number = 0; i < this._activeRopeJumpingAnimations.length; i++) {
            const tl: gsap.core.Timeline = gsap.timeline({paused: true});
            tl.add(() => {
                this._activeRopeJumpingAnimations[i].visible = true
            });
            //Start rope jumping animation at random position, then loop
            tl.add(this._activeRopeJumpingAnimations[i].getAnimation([MathHelper.randomIntInRange(0, this._ropeJumpingAnimationTexturesLength), this._ropeJumpingAnimationTexturesLength]).timeScale(1.2));
            tl.add(gsap.timeline({repeat: -1}).add(this._activeRopeJumpingAnimations[i].getAnimation().timeScale(1.2)));
            this._activateRopeJumpingTLs.push(tl);
        }
    }

    private createActivateBoxTrainersTL(): void {
        this._activateTrainingTLs = [];
        for (let i: number = 0; i < this._activeTrainingBoxerAnimations.length; i++) {
            const tl: gsap.core.Timeline = gsap.timeline({paused: true});
            tl.add(() => {
                this._activeTrainingBoxerAnimations[i].visible = true
            });
            //Start boxer animation at random position, then loop
            tl.add(this._activeTrainingBoxerAnimations[i].getAnimation([MathHelper.randomIntInRange(0, this._trainingBoxerAnimationTexturesLength), this._trainingBoxerAnimationTexturesLength]).timeScale(0.25));
            tl.add(gsap.timeline({repeat: -1}).add(this._activeTrainingBoxerAnimations[i].getAnimation().timeScale(0.25)));
            this._activateTrainingTLs.push(tl);
        }
    }

    get multiplierTexts(): PIXI.BitmapText[] {
        return this._multiplierTexts;
    }

    get xSplitXs(): PIXI.Sprite[] {
        return this._xSplitXs;
    }

    set isShowEnhancerAborted(value: boolean) {
        this._isShowEnhancerAborted = value;
    }

    set isSpinResultAborted(value: boolean) {
        this._isSpinResultAborted = value;
    }
}